export default __webpack_public_path__ + "static/media/arrow-right.a8734858.svg";